<p-toast class="global"
         [class.show]="globalMsg.length !== 0"
         position="bottom-center">
</p-toast>
